export default {
  rotateView: 'rotate-view',
  rotateBtn: 'rotate-btn',
  cropBtn: 'crop-btn',
  tabs: 'crop-tabs',
};
